<template>
  <div class="register-outer d-flex align-items-center justify-content-center">
    <div v-loading="getCanRegisterLoading" class="register">
      <h5 class="py-4 text-white mb-3 fw-bold" style="background: #0d6efd">{{title}} <text v-if="title">：“明石杯”微纳传感技术与智能应用赛</text></h5>
      <div class="container-md bg-white p-5 max-width-1000 d-flex align-items-center flex-column" v-if="!showSuccess">
        <h5 class="fw-bold ">参赛队伍注册 </h5>
        <text class="mb-5 text-secondary text-danger" style="font-size: 14px;margin-top: 10px;" >开放时间：{{register_start}} ~ {{register_end}}</text>

        <el-form :disabled="!can_register"    :model="form" size="large" label-width="auto" style="max-width: 600px" ref="ruleFormRef"
                 :rules="rules">
          <el-form-item label="手机号：" prop="Phone">
            <el-input v-model="form.Phone"/>
          </el-form-item>
<!--          验证码的提示-->
          <el-space fill class="mb-2" v-show="showCountState===2 || showCountState===3">
            <el-alert type="info" show-icon :closable="false" >
              <p class="text-start mb-0 small">如果收不到短信验证码?</p>
              <p class="text-start mb-0 small">1. 请再重试一次；</p>
              <p class="text-start mb-0 small">2. 换其他同学的非移动手机号重试，通常出问题的是移动的号码；</p>
              <p class="text-start mb-0 small">3. 如果反复重试还是收不到验证码短信，请联系技术支持人员 13361361078，微信同号</p>
            </el-alert>
          </el-space>
          <el-form-item label="验证码：" prop="Code" class="w-100">
            <div class="d-flex align-items-center justify-content-between w-100 ">
              <el-input v-model="form.Code" class="me-2"/>
              <div class="position-relative flex-column code flex-shrink-0 border border-primary rounded-2" @click="sentCode" v-if="showCountState===1">
                <a class="text-primary point-curser text-decoration-none"
                   :disabled="!phoneCurrent">
                  点击发送
                </a>
              </div>
              <div class="position-relative flex-column code flex-shrink-0 border border-primary rounded-2"  v-if="showCountState===2">
                <a class="text-primary point-curser text-decoration-none"
                   :disabled="!phoneCurrent">
                  正在发送
                  <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                </a>
              </div>
              <div class="position-relative flex-column code flex-shrink-0 border border-primary rounded-2" v-if="showCountState===3">
                <a class="text-primary not-allowed-curser text-decoration-none" v-if="showCountState===3">{{ count }} s</a>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="邮箱：" prop="Email">
            <el-input v-model="form.Email" autocomplete="false"/>
          </el-form-item>
          <el-form-item label="密码：" prop="Password">
            <el-input v-model="form.Password"  autocomplete="new-password"  type="text" onfocus="this.type='password'"/>
<!--            <el-input-->
<!--                v-model="form.Password"-->
<!--                type="password"-->
<!--                placeholder="请输入"-->
<!--                show-password-->
<!--            />-->
          </el-form-item>
          <el-form-item label="确认密码：" prop="PasswordConfirm">
            <el-input v-model="form.PasswordConfirm" type="text"  autocomplete="new-password" onfocus="this.type='password'"/>
<!--            <el-input-->
<!--                v-model="form.PasswordConfirm"-->
<!--                type="password"-->
<!--                placeholder="请输入"-->
<!--                show-password-->
<!--            />-->
          </el-form-item>
          <el-form-item label="姓名：" type="text" prop="Contact" autocomplete="off">
            <el-input v-model="form.Contact"/>
          </el-form-item>
<!--          <el-form-item label="证件号码：" type="text" prop="CardId" autocomplete="off">-->
<!--            <el-input v-model="form.CardId"/>-->
<!--          </el-form-item>-->
          <el-form-item label="证件号码：" prop="CardId" >
            <el-input type="text" v-model="form.CardId" >
              <template #prepend>
                <el-select v-model="form.DocumentType" placeholder="证件" style="width: 100px">
                  <el-option v-for="item of DOCUMENTTYPES" :key="item.ID" :value="item.ID" :label="item.Name"/>
                </el-select>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="所属大学：" prop="School">
            <div class="d-flex align-items-center justify-content-between w-100 ">
              <el-input v-model="form.School" class="me-2" @click="showSchool" disabled/>
              <div class="position-relative flex-column code flex-shrink-0 border border-primary rounded-2" @click="showSchool">
                <a class="text-primary point-curser text-decoration-none"  >
                  选择大学
                </a>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="参赛组别：" prop="Level">
            <el-select
                v-model="form.Level"
                placeholder="请选择"
                clearable
            >
              <el-option v-for="op in LEVELS" :label="op.Name" :value="op.ID" :key="op.ID"/>
            </el-select>
          </el-form-item>
          <p class="text-start mt-5 lh-base small">注意:</p>
          <p class="text-start lh-base small ">1)以参赛队伍为单位进行报名,每队指定队长1名，由队长统一报名并添加队员，队员无需重复注册;</p>
          <p class="text-start lh-base small">2)每支参赛队伍由5名以内学生组成，每位学生只能参加一支参赛队伍;</p>
          <p class="text-start lh-base mb-5 small">3)每支参赛队伍可指定1-2名本校教师作为指导教师,每位指导教师最多同时指导2支参赛队伍;</p>
          <div class=" px-3 d-flex align-items-center justify-content-center flex-column mt-4">
            <el-button type="primary" class="btn-save"
                       v-loading="loading"
                       @click="saveConfire"
            >立即注册
            </el-button>

          </div>
        </el-form>
        <el-button type="danger" text class="mt-2" v-if="!can_register">当前时间段已暂停注册</el-button>
        <el-button type="primary" text class="mt-2" @click="goLogin">已有账号？去登录</el-button>
        <!--      <fieldset :disabled="!can_register">-->
        <!--      </fieldset>-->
      </div>
      <div class="container-md bg-white p-5 max-width-1000 d-flex align-items-center flex-column" v-if="showSuccess">
        <h5 class="py-4 bg-white mb-3 fw-bold">参赛队伍注册</h5>
        <img src="../assets/images/success.svg" alt="">
        <h3 class="py-4 bg-white mb-3 fw-bold">注册（报名）成功！</h3>
        <h5 class="py-4 bg-white mb-3 fw-bold">{{ successCount }}秒后自动跳转登录页，<a class="text-primary point-curser"
                                                                              @click="goLogin">立即登录</a></h5>
      </div>
      <SchoolListModel v-if="dialogVisible" @choised="schoolChoised"></SchoolListModel>
    </div>
  </div>
</template>

<script setup>
import {reactive, onMounted, ref, onBeforeUnmount, computed} from 'vue'
import {ElMessage, ElMessageBox} from "element-plus";
import {LEVELS,DOCUMENTTYPES} from "@/utils/commonSetting"
import {useStore} from 'vuex'
const store = useStore()
import router from "@/router";
import {addTeam, sendSmsCode} from "@/api/login";
import {validateCardId, validateForm} from "@/utils/formValidate";
import SchoolListModel from "@/components/SchoolListModel"
const getCanRegisterLoading = ref(true)
const title = computed(()=>store.state.sysModel.title)
// const can_register = computed(()=>store.state.sysModel.can_register) // todo
const can_register = ref(true)
const ruleFormRef = ref()
const successCount = ref(3) // 成功后的读秒
const showSuccess = ref(false)
const dialogVisible = ref(false)
const form = reactive({
  Phone: "", // 手机
  Code: null, // 验证码
  Email: null, // 邮箱
  Password: null,// 密码
  PasswordConfirm: null,// 确认密码
  Contact: null, // 姓名
  CardId: null, // 身份证
  School: null, // 学校
  Level: null, // 组别
  DocumentType:"1"

})
// 验证
const validateCard = (rule, value, callback)=>{
  if (!value || !value.trim()) {
    callback(new Error('请输入证件号'))
  }else{
    const v = validateCardId(form.DocumentType,value)
    if(v){
      callback()
    }else{
      if(form.DocumentType==1){
        callback(new Error("请输入正确的身份证号"))
      }else{
        callback(new Error("请输入正确的护照号"))
      }

    }
  }

}
const rules = ({
  Phone: [
    {required: true, message: '请输入手机号', trigger: ['change', 'blur']},
    {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: ['blur']}
  ],
  Code: [{required: true, message: '请输入验证码', trigger: ['change', 'blur']}],
  Email: [
      {required: true, message: '请输入邮箱', trigger: ['change', 'blur']},
    {pattern: /^[a-zA-Z0-9_.]+@[a-zA-Z0-9-]+[.a-zA-Z]+$/, message: '请输入正确的邮箱', trigger: ['blur']}
  ],
  Password: [{required: true, message: '请输入密码', trigger: ['change', 'blur']}],
  PasswordConfirm: [{required: true, message: '请再次输入密码', trigger: ['change', 'blur']}],
  Contact: [{required: true, message: '请输入姓名', trigger: ['change', 'blur']}],
  CardId: [
    {required: true, message: '请输入证件号码', trigger: ['change', 'blur']},
    {validator: validateCard, trigger: ['blur']}
  ],
  School: [{required: true, message: '请选择学校', trigger: ['change', 'blur']}],
  Level: [{required: true, message: '请选择组别', trigger: ['change','blur']}],
})
const getCodeLoading = ref(true)
const loading = ref(false)
const base64 = ref('')
const count = ref(0)
let interval = null
let interval2 = null
const showCountState = ref(1) // 1可以发送验证码，2，号码正在验证中 3，已发送
const phoneCurrent = ref(false) // 电话号码格式正确
let ChoisedSchool; // 被选择的信息
const register_start = computed(()=>store.state.sysModel.register_start) // 注册开始时间
const register_end = computed(()=>store.state.sysModel.register_end) // 注册结束时间

onMounted( () => {
  showSuccess.value = false
  getSettingFun()
})
onBeforeUnmount(() => {
  stopCount() // 停止验证码定时器
  stopLoginSuccessCount()
})

// 获取配置信息
const getSettingFun =async ()=>{
  getCanRegisterLoading.value = true
  await store.dispatch("sysModel/getAllsettingsFun") // 获取系统配置
  getCanRegisterLoading.value = false
}

const sentCode = async () => {
  if(!can_register.value){
    return ElMessage.warning("当前时间段已暂停注册")
  }
  if (phoneNumChange()) { // 1，判断号码是否合格
    showCountState.value = 2
    // 2，发送验证码
    const cres = await sendSmsCode({tel: form.Phone, Mode: 0})

    if (cres.err_code === 0) { // 已经发送
      showCountState.value = 3
      startCount()
    } else {
      showCountState.value = 1
      return ElMessage.warning("获取验证码失败")
    }
    //2 验证号码是否被使用


  } else {
    return ElMessage.warning("请输入正确的电话号码")
  }

}
// 验证输入的电话号码
const phoneNumChange = () => {
  if (!form.Phone || !form.Phone.trim()) {
    phoneCurrent.value = false
    return false
  }
  var phoneReg = /^1[3-9]\d{9}$/
  if (phoneReg.test(form.Phone)) {
    phoneCurrent.value = true
    return true
  } else {
    phoneCurrent.value = false
    return false
  }
}
const startCount = () => {
  interval && clearInterval(interval)
  count.value = 60
  interval = setInterval(() => {
    count.value = count.value - 1
    if (count.value === 0) {
      clearInterval(interval)
      showCountState.value = 1
    }
  }, 1000)
}
const stopCount = () => {
  interval && clearInterval(interval)
}
const saveConfire = async ()=>{
  const isValid = await validateForm(ruleFormRef.value)
  if (!isValid) {
    return
  }
  ElMessageBox.alert('参赛队仅允许队长注册，且注册后队长身份不可变动，其他队员由队长进行添加', '注册', {
    confirmButtonText: '已知悉，继续注册',
    callback: (action) => {
      if(action==='confirm'){ // 确定
        save()
      }
    },
  })
}
//提交
const save = async () => {
  // const isValid = await validateForm(ruleFormRef.value)
  // if (!isValid) {
  //   return
  // }
  try {
    loading.value = true
    const params = {...form, UniversityId: ChoisedSchool.ID}
    const res = await addTeam(params) // todo
    loading.value = false
    if (res.err_code === 0) {
      ElMessage.success("注册成功")
      showSuccess.value = true
      startLoginSuccessCount()
    } else {
      ElMessage.warning(res.err_msg || "注册失败")
    }
  }catch{
    loading.value = false
    ElMessage.warning("请检查您的注册信息是否完整")
  }

}
// 成功注册后的验证码定时器
const startLoginSuccessCount = () => {
  interval2 && clearInterval(interval2)
  successCount.value = 3
  interval2 = setInterval(() => {
    successCount.value = successCount.value - 1
    if (successCount.value === 0) {
      clearInterval(interval2)
      goLogin()
    }
  }, 1000)
}
const stopLoginSuccessCount = () => {
  interval2 && clearInterval(interval2)
}


// 去登录
const goLogin = () => {
  router.replace({path: "/login"})
}

// 显示学校模态框
const showSchool = () => {
  if(!can_register.value){
    return ElMessage.warning("当前时间段已暂停注册")
  }
  dialogVisible.value = true
}

// 选择学校
const schoolChoised = (sh) => {
  if (sh) {
    form.School = sh.Name
    ChoisedSchool = sh
  }
  dialogVisible.value = false
}


</script>

<style scoped lang="scss">
.register-outer {
  width: 100%;
  height: 100%;
  //height: 100vh;
  overflow-x: hidden;
}
.register{
  width: 100%;
  //max-width: 1200px;
  height: 100%;
}


.code {
  width: 110px;
  height: 40px;
  overflow: hidden;

  .code-img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
}

.btn-save {
  width: 200px;
  height: 40px;
}

.el-card__header {
  background: #0d6efd !important;
}

.reload-base {
  bottom: -28px;
  left: 10px;
}

</style>
